<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 small">
        {{year}} © Maltia Servicios Financieros
      </div>
      <div class="col-sm-6 small">
        <div class="text-sm-end d-none d-sm-block">
          Development by Cleversec
        </div>
      </div>
    </div>
  </div>
</footer>
